import { render, staticRenderFns } from "./ChambersTable.vue?vue&type=template&id=2f36f72c&"
import script from "./ChambersTable.vue?vue&type=script&lang=js&"
export * from "./ChambersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports